export default __webpack_public_path__ + "static/media/JavaScript-Quiz.bbfb45fa.PNG";